import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sb-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './footer.component.html',
    styleUrls: ['footer.component.scss'],
})
export class FooterComponent implements OnInit {
    @Input() dark = false;
    currentYear: number;
    constructor() {
        // Initialize currentYear with the current year
    this.currentYear = new Date().getFullYear();
    }
    ngOnInit() {}
}
